<router-outlet *ngIf="auth.user; else accessForbidden"></router-outlet>
<ng-template #accessForbidden>
  <h3 style="position: absolute;top: 50%;left: 40%;">{{ 'app.textInfo' | transloco }}</h3>
</ng-template>
